import { Vue } from 'vue-property-decorator';
const focus = {
    inserted: function (el, binding) {
        if (binding.value) {
            el.focus();
        }
    },
    update: function (el, binding) {
        if (binding.value) {
            Vue.nextTick(function () {
                el.focus();
            });
        }
    },
};
export default focus;
